import { StyleSheet, Dimensions } from 'react-native';
import { SHOULD_RENDER_MOBILE_DESIGN } from '../../constants';

const width = Dimensions.get('window').width;
const styles = StyleSheet.create({
  body: {
    pointerEvents: 'none',
    position: 'fixed',
    zIndex: 10000,
    left: 0,
    right: 0
  },
  container: {
    pointerEvents: 'auto',
    position: 'absolute',
    left: 0,
    right: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  webPositionContainer: {
    position: 'fixed'
  },
  popoverMessageWrapper: {
    borderRadius: 8,
    display: 'flex',
    flexDirection: 'row',
    paddingTop: 10,
    paddingBottom: 10,
    paddingEnd: 16,
    width: SHOULD_RENDER_MOBILE_DESIGN ? width - 32 : 600,
    justifyContent: 'space-between'
  },
  popoverLeftChild: {
    flexDirection: 'row',
    flexShrink: 1,
    alignItems: 'center'
  },
  popovertext: {
    flexShrink: 1
  },
  notificationIconWrapper: {
    borderRadius: 9,
    marginEnd: 14,
    marginStart: 14,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  dismissButton: {
    paddingStart: 14
  }
});

export default styles;
